import qs from "qs";
import _ from "lodash";
import castit from "castit";

import state from "../state";


export function captureQueryString() {
	const queryString = qs.parse(window.location.search, { ignoreQueryPrefix: true });
	let _queryString = {};
	_.forEach(queryString, (value, key) => {
		_queryString[key] = castit(value);
	});
	console.log("CAPTURED QUERY STRING", _queryString);

	try {
		/* eslint-disable */
		if (defaultParams) {
			_queryString = _.assign({}, defaultParams, _queryString);
		}
		/* eslint-enable */
	} catch (e) {
		console.warn(e);
	}
	console.log("Final QUERY STRING", _queryString);
	state.set(["_config"], _queryString);
}

export function getConfigParam(key, defaultValue=null) {
	let result = defaultValue;
	if (key) {
		if (!state.exists(["_config"])) {
			captureQueryString();
		}

		if (state.exists(["_config", key])) {
			result = state.get(["_config", key]);
		}
	}

	return result;
}

const AVAILABLE_STYLING_OPTIONS = ["fontColor", "backgroundColor", "backgroundMediaUrl", "fontWeight", "fontFamily","swiperButtonsColor"];

export function injectCustomStyling() {
	const styleOverrides = [];
	const styleOverridesTargeted = [];
	AVAILABLE_STYLING_OPTIONS.forEach(option => {
		let val = getConfigParam(option);
		if (val) {
			switch (option) {
				case "fontColor": {
					styleOverrides.push(`color: ${val};`)
					break;
				}
				case "fontWeight": {
					styleOverrides.push(`font-weight: ${val};`)
					break;
				}
				case "fontFamily": {
					styleOverrides.push(`font-family: ${val}!important;`)
					break;
				}
				case "backgroundColor": {
					styleOverrides.push(`background-color: ${val};`)
					break;
				}
				case "swiperButtonsColor": {
					styleOverridesTargeted.push(`.swiper-button-prev { background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'${val}'%2F%3E%3C%2Fsvg%3E")!important;}`);
					styleOverridesTargeted.push(`.swiper-button-next { background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'${val}'%2F%3E%3C%2Fsvg%3E")!important;}`);
					styleOverridesTargeted.push(`.swiper-pagination .swiper-pagination-bullet {background-color:${val};}`)
					break;
				}	
				case "backgroundMediaUrl": {
					styleOverrides.push(`
						background: url('${val}') no-repeat center center fixed; 
						-webkit-background-size: cover;
						-moz-background-size: cover;
						-o-background-size: cover;
						background-size: cover;
					`);
					break;
				}
				default: {
					console.log("Unhandled styling option", option);
				}
			}
		}
	});
	console.log("Provided overrides", styleOverrides);
	if (!_.isEmpty(styleOverrides) || !_.isEmpty(styleOverridesTargeted)) {
		const styleEl = document.createElement("style");
		styleEl.type = "text/css";
		let val= "";
		if (!_.isEmpty(styleOverrides)) {
			val += `body {${styleOverrides.join("\n")}}`;
		}
		if (!_.isEmpty(styleOverridesTargeted)) {
			val += styleOverridesTargeted.join("\n");
		}
		styleEl.innerHTML = val;
		console.log("Injecting styles")
		document.getElementsByTagName("head")[0].appendChild(styleEl);
	}
}